module.exports = __webpack_public_path__ + "static/media/sickle.11c0987a.svg";